import { Resolvable } from './resolvable.js';
export class CalmControlDetail {
    constructor(originalJson, requirement, configUrl, config) {
        this.originalJson = originalJson;
        this.requirement = requirement;
        this.configUrl = configUrl;
        this.config = config;
    }
    toCanonicalSchema() {
        const config = (this.configUrl && this.configUrl.isResolved) ? this.configUrl.value : this.config;
        return {
            'requirement-url': this.requirement.reference,
            ...config
        };
    }
    static fromSchema(schema) {
        const controlRequirement = new Resolvable(schema['requirement-url']);
        if ('config-url' in schema) {
            return new CalmControlDetail(schema, controlRequirement, new Resolvable(schema['config-url']));
        }
        else {
            return new CalmControlDetail(schema, controlRequirement, undefined, schema.config);
        }
    }
    toSchema() {
        return this.originalJson;
    }
}
export class CalmControl {
    constructor(originalJson, description, requirements) {
        this.originalJson = originalJson;
        this.description = description;
        this.requirements = requirements;
    }
    toCanonicalSchema() {
        return {
            description: this.description,
            requirements: this.requirements.map(req => req.toCanonicalSchema())
        };
    }
    static fromSchema(schema) {
        const requirements = (schema.requirements || []).map(CalmControlDetail.fromSchema);
        return new CalmControl(schema, schema.description, requirements);
    }
    toSchema() {
        return this.originalJson;
    }
}
export class CalmControls {
    constructor(originalJson, data) {
        this.originalJson = originalJson;
        this.data = data;
    }
    toCanonicalSchema() {
        return Object.fromEntries(Object.entries(this.data).map(([key, control]) => [key, control.toCanonicalSchema()]));
    }
    static fromSchema(schema) {
        const controls = {};
        for (const [controlId, controlSchema] of Object.entries(schema)) {
            controls[controlId] = CalmControl.fromSchema(controlSchema);
        }
        return new CalmControls(schema, controls);
    }
    toSchema() {
        return this.originalJson;
    }
}
//# sourceMappingURL=control.js.map